module.exports = __webpack_public_path__ + "static/img/Citibank.492d0adf.png";